import CustomModal from './../../../../../components/Modal/CustomModal';
import CustomGenericTittleIconDataChip from './../../../../../components/CustomGenericTittleIconDataChip';
import {DATE_TIME_FORMAT_NAME_MODEL, EMPTY_VALUES, getDateFormat} from './../../../../../Apis/functions';
import {
    DescriptionTittle,
    MealTimeTitle,
    ScheduleTitle,
    ServiceTypeChip,
} from '../../../../../components/buttons/IconButtons';

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 *
 * RequestSummaryModal
 * Displays a modal with the summary details of a meal request (diner summary).
 * @param {Object} props - Component props.
 * @param {boolean} props.open - Determines whether the modal is visible.
 * @param {Function} props.onHide - Callback to close the modal.
 */

const RequestSummaryModal = (props) => {
    const { open, onHide, item } = props;

    return (
        <CustomModal
            title={'diner_summary'}
            show={open}
            size='m'
            buttonConfirm='confirm'
            cancelButton={false}
            confirmButton={false}
            onHide={onHide}
            classNameBody="pt-2"
        >
            <div className='row'>
                <div className={'col-12'}>
                    <CustomGenericTittleIconDataChip Icon={DescriptionTittle} title={'description'} />
                    <span className='ibl-description ibl-font-w-500 line-height'>{item?.description}</span>
                </div>

                <div className={'row mt-2'}>
                    <div className='col-6 mt-4 pl-0'>
                        <CustomGenericTittleIconDataChip
                            Icon={ScheduleTitle}
                            title={'serving_date'}
                            name={
                                item?.servingDate ? getDateFormat(item?.servingDate, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth) : EMPTY_VALUES.DEFAULT
                            }
                            key={item?.id}
                            IconAvatar={ServiceTypeChip}
                        />
                    </div>
                    <div className='col-6 mt-4 pl-0'>
                        <CustomGenericTittleIconDataChip
                            Icon={MealTimeTitle}
                            title={'order_date'}
                            name={
                                item?.createdAt
                                    ? getDateFormat(item?.createdAt, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth)
                                    : EMPTY_VALUES.DEFAULT
                            }
                            key={item?.id}
                            IconAvatar={ServiceTypeChip}
                        />
                    </div>

                    <div className='col-6 mt-4 px-0'>
                        <CustomGenericTittleIconDataChip
                            Icon={MealTimeTitle}
                            title={'service_time'}
                            name={item?.mealTimeName || EMPTY_VALUES.DEFAULT}
                            key={item?.id}
                            showAvatar={false}
                        />
                    </div>
                </div>
            </div>
        </CustomModal>
    );
};

export default RequestSummaryModal;
